/** @format */

import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabsModule } from '@angular/material/tabs';
import { VizFormModule } from '../common/components/form/form.module';
import { utils } from '../common/utils';
import { BookingCancelReason, TBooking } from '../core/entities';
import { SessionService } from '../session.service';


@Component({
  templateUrl: './booking.cancel.dialog.html',
  standalone: true,
  imports: [
    VizFormModule,
    MatTabsModule,
    MatSelectModule,
    MatInputModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatCheckboxModule,
  ],
})
export class BookingCancelDialogComponent {
  form: UntypedFormGroup;
  _common = _common;

  object: TBooking;
  cancelReasons = BookingCancelReason;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    public session: SessionService,
    public http: HttpClient,
    public snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<BookingCancelDialogComponent>
  ) {
    this.object = data.object;

    this.form = this.fb.group({
      cancelReasonCode: ['', Validators.required],
      cancelReason: [''],
    });
  }

  updateForm() {
    this.form.controls['cancelReason'].setValidators([]);
    if (this.form.value.cancelReasonCode == BookingCancelReason.other) {
      this.form.controls['cancelReason'].setValidators([Validators.required]);
    }
    utils.updateValidity(this.form);
  }
  save() {
    if (!this.form.valid)
      return utils.validateAllFormFields(this.form, {
        snackBar: this.snackBar,
      });
    let query = Object.assign({}, this.form.value);
    this.dialogRef.close(query);
  }

  cancel() {
    this.dialogRef.close();
  }
  closeDialog() {
    this.dialogRef.close();
  }
}
